import React from 'react';
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {Delete} from "@mui/icons-material";
import TextField from "@mui/material/TextField";

const props = [
    {
        key: 'ratio',
        type: 'number',
        label: 'Ratio'
    },
    {
        key: 'defaultValue',
        type: 'number',
        label: 'Default value'
    },
    {
        key: 'priceChange',
        type: 'number',
        label: 'Price change'
    },
    {
        key: 'maxValue',
        type: 'number',
        label: 'Max width'
    },
]

function AdminSizeParam({param, onChange, onDelete}) {
    const set = (id, value) => {
        param.props = param.props || {};
        param.props[id] = Number(value);
        onChange(param);
    }

    return (
        <div>
            <Typography fontWeight={500} sx={{pb: 2}}>
                {param.key}
                <IconButton onClick={onDelete}><Delete/></IconButton>
            </Typography>
            {props.map(prop => <><Typography >
                {prop.label}
            </Typography>
            <TextField size={'small'} type={prop.type} value={param.props?.[prop.key]} sx={{pb: 2}}
                       onChange={event => set(prop.key, event.target.value)}/></>)}
        </div>
    );
}

export default AdminSizeParam;
